<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round
                    @click="openDialog(null)">添加</el-button></el-col>
        </el-row>

        <table style="width: 80%;">
            <tr v-for="item in newsData" :key="item.id" @click="rowClick(item)">
                <td class="col-md-2 content_padding news_content_date">
                    <div class="card-body news_content_date_body">
                        <h3> {{item.monthDay}} </h3>
                        <p>— {{item.year}} —</p>
                    </div>
                </td>
                <td class="col-md-6-1 content_padding">
                    <div class="col-md-6-1 content_padding">
                        <div class="overlay  border-0 text-left pb-2">
                            <h5 class="card-title news_title">{{item.title}}</h5>
                            <p class="card-text text-muted">
                                {{item.summary}}
                            </p>
                        </div>
                    </div>
                </td>
                <td class="col-md-2 content_padding">
                    <div class="overlay border-0">
                        <img class="card-img" :src="item.url" alt="Card image" style="max-height: 9rem;">
                    </div>
                </td>
                <td class="col-md-1-1 content_padding">
                    <el-button type="primary" size="mini" icon="el-icon-edit" circle
                        @click="openDialog(item)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" circle
                        @click="deleteNews(item.id)"></el-button>
                    <el-button type="warning" size="mini" icon="el-icon-star-off" circle
                        @click="showDetail(item.id)"></el-button>
                </td>

            </tr>
        </table>
        <!-- 详情 弹窗 -->
        <el-dialog title="提示" :visible.sync="isdetail" width="30%" :before-close="detailClose">
            <div v-html="detailInfo" class="preview"></div>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisible" width="60%">
            <el-form :model="currentRow">
                <el-form-item label="日期" :label-width="formLabelWidth">
                    <el-date-picker v-model="currentRow.happenDate" type="date" @change="dateChange"
                        style="display: inline;margin-left: 5px; " placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="标题" :label-width="formLabelWidth">
                    <el-input placeholder="请输入标题" v-model="currentRow.title" style="display: inline;margin-left: 5px; "
                        clearable required>
                    </el-input>
                </el-form-item>
                <el-form-item label="概述" :label-width="formLabelWidth">
                    <el-input placeholder="请输入概述" v-model="currentRow.summary"
                        style="display: inline;margin-left: 5px; " clearable required>
                    </el-input>
                </el-form-item>
                <el-form-item label="详情" :label-width="formLabelWidth">
                    <!-- <vue-editor v-model="currentRow.content" :options="editorOptions" ></vue-editor> -->
                    <ckeditor v-model="currentRow.content" :config="editorConfig"></ckeditor>
                </el-form-item>
                <el-form-item label="图片" :label-width="formLabelWidth">
                    <el-upload class="avatar-uploader" :before-upload="beforeUpload" action="" :show-file-list="false"
                        :on-change="handleFileChange" :file-list="fileList">
                        <img v-if="isImage" :src="currentRow.url" class="avatar" />
                        <video v-else-if="isVideo" :src="currentRow.url" controls class="avatar">
                            Your browser does not support the video tag.
                        </video>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveInfo">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>

    import { submitInsNews, getNewsNoContentList, delInsnews, getNewsAllList } from "@/api/rbac/news";

    //  import { VueEditor} from "vue2-editor";
    export default {
        components: {
            //   VueEditor
        },
        data() {
            return {
                dialogVisible: false,
                newsData: [],
                currentRow: { id: 0, title: '', summary: '', content: '', year: '', monthDay: '', url: '', happenDate: new Date() },
                formLabelWidth: '120px',
                fileList: [],
                isImage: false,
                isVideo: false,
                editorConfig: {
                    extraPlugins: 'font,colorbutton', // 添加字体和颜色插件
                    toolbar: [
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
                        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                        { name: 'colors', items: ['TextColor', 'BGColor'] },
                        // { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
                        { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
                        { name: 'links', items: ['Link', 'Unlink'] },
                    ],
                    font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
                    fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
                    language: 'zh-cn'
                },
                isdetail: false,
                detailInfo: "",
                isFirstOpen: true,
            }
        },
        created() {
            this.loadDataList();
        },
        methods: {
            async loadDataList() {
                try {
                    getNewsNoContentList({ tableType: 1 }).then(res => {
                        if (res.data.length == 0) {
                            // console.log(this.dataList)
                        }
                        else {
                            this.newsData = res.data;
                            this.newsData.forEach(comNew => {
                                comNew.url = "../../../assets/img/News/" + comNew.url;
                            });
                        }
                    })
                } catch (error) {
                    console.error('获取失败:', error);
                }
            },
            rowClick(item) {
                this.currentRow = { ...item }
            },

            openDialog(item) {
                this.dialogVisible = true

                // 深拷贝避免直接修改原数据
                if (item) {
                    this.currentRow = { ...item }
                    //获取明细
                    try {
                        getNewsAllList({ tableType: 1, strWhere: ' and a.id=' + item.id }).then((res) => {
                            if (res.data.length == 0) {
                                this.content = '';
                            }
                            else {
                                this.currentRow.content = res.data[0].content
                            }
                        });
                    } catch (error) {
                        console.log(error);
                    }
                    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
                    const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mkv', ''];
                    const extension = this.currentRow.url.split('.').pop().toLowerCase();
                    if (imageExtensions.includes(extension)) {
                        this.isImage = true;
                        this.isVideo = false;
                    }
                    if (videoExtensions.includes(extension)) {
                        this.isImage = false;
                        this.isVideo = true;
                    }
                } else {
                    this.currentRow = { id: 0, title: '', summary: '', content: '', year: '', monthDay: '', url: '' };
                }
                if (this.isFirstOpen) {
                    this.checkInterval = setInterval(() => {
                        const dynamicDivs = document.querySelectorAll('.cke_notifications_area');
                        if (dynamicDivs.length > 0) {
                            dynamicDivs.forEach((div) => {
                                div.style.display = 'none'
                            });
                            clearInterval(this.checkInterval); // 停止轮询
                            this.isFirstOpen = false;
                            // 可以在这里执行加载后的操作
                            // 如果只需要检查一次，可以调用 clearInterval(this.checkInterval);
                        }
                    }, 100); // 每 500ms 检查一次
                }
            },
            beforeUpload(file) {
                const isImage = file.type.startsWith('image/');
                const isVideo = file.type.startsWith('video/');
                if (isImage) {
                    this.isImage = true;
                    this.isVideo = false;
                } else if (isVideo) {
                    this.isVideo = true;
                    this.isImage = false;
                }
                return false; // 阻止自动上传
            },
            handleFileChange(file, fileList) {
                //this.fileList = fileList;
                console.log('thisfileList', this.fileList)
                console.log('fileList', fileList)
                this.fileList = [];
                this.fileList.push(file)
                if (file.status === 'ready') {
                    // 当文件状态为 ready 时，生成预览 URL
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.currentRow.url = e.target.result;
                    };
                    reader.readAsDataURL(file.raw);
                }
            },
            dateChange(value) {
                const date = new Date(value);
                const year = String(date.getFullYear());
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1，并确保两位数格式
                const day = String(date.getDate()).padStart(2, '0'); // 确保两位数格式
                this.currentRow.year = year;
                this.currentRow.monthDay = month + '.' + day

            },
            saveInfo() {
                if (this.currentRow.happenDate == null || this.currentRow.happenDate.String) {
                    return alert("请选择日期")
                }
                if (!String(this.currentRow.title).trim()) {
                    return alert("请填写标题")
                }
                if (!String(this.currentRow.summary).trim()) {
                    return alert("请填写概述")
                }
                if (!String(this.currentRow.content).trim()) {
                    return alert("请填写详情")
                }
                if (this.fileList.length == 0 && this.currentRow.id == 0) {
                    return alert("请选择图片")
                }
                const formData = new FormData();
                this.fileList.forEach((file) => {
                    formData.append('files[]', file.raw);
                });
                formData.append("strType", "insNews")
                formData.append("ID", this.currentRow.id)
                formData.append("title", this.currentRow.title)
                formData.append("content", this.currentRow.content)
                formData.append("happenDate", this.currentRow.happenDate)
                formData.append("year", this.currentRow.year)
                formData.append("monthDay", this.currentRow.monthDay)
                formData.append("Summary", this.currentRow.summary)
                try {
                    submitInsNews(formData).then(res => {
                        if (res.length == 0) {
                            alert('失败');
                        }
                        else {
                            alert('成功');
                            this.dialogVisible = false;
                            this.currentRow = { id: 0, title: '', Summary: '', content: '', year: '', monthDay: '', url: '', happenDate: new Date() };
                            this.loadDataList();

                        }
                    })
                } catch (error) {
                    alert('未成功');
                }
            },
            showDetail(id) {
                try {
                    getNewsAllList({ tableType: 1, strWhere: ' and a.id=' + id }).then((res) => {
                        if (res.data.length == 0) {
                            this.content = '';
                        }
                        else {
                            this.detailInfo = res.data[0].content;
                            this.detailInfo = this.detailInfo.replace(/<p>\s*<span\s+style="color:\s*black;">/gi, `<p><span style="color: white;">`);

                        }

                    });

                } catch (error) {
                    console.log(error);
                }
                this.isdetail = true;
            },
            deleteNews(id) {
                this.$confirm('确定删除该, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    try {
                        delInsnews(id).then(res => {
                            if (res.data == "ok") {
                                this.loadDataList();
                            }
                        })

                        this.currentRow = {};
                    } catch (error) {
                        console.error('删除失败:', error);
                    }
                }).catch(() => {
                });
            },
            detailClose() {
                this.detailInfo = "";
                this.isdetail = false;
            },
        }
    }
</script>
<style scoped>
    .avatar-uploader {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 178px;
        height: 178px;
    }

    .avatar-uploader:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    :deep(.ql-editor) {
        background-color: #424242 !important;
    }
</style>